import React, { useEffect, useState } from 'react';
import { readMapViewInfo } from '../../hooks/useMapViewInfo';

/**
 * Lectura `lat, lng | zoom` del pie del mapa. Con `liveMap` sigue el movimiento
 * frame a frame sin re-renderizar la página; sin él, muestra `mapInfo`.
 */
export default function MapCoordsReadout({ mapInfo, liveMap = null }) {
  const [liveInfo, setLiveInfo] = useState(null);

  useEffect(() => {
    if (!liveMap) {
      setLiveInfo(null);
      return undefined;
    }
    const sync = () => setLiveInfo(readMapViewInfo(liveMap));
    sync();
    liveMap.on('move', sync);
    return () => {
      try { liveMap.off('move', sync); } catch (_) { /* mapa ya removido */ }
    };
  }, [liveMap]);

  const info = liveInfo || mapInfo;

  if (info?.lat && info?.lng) {
    return (
      <>
        <span>
          {info.lat}, {info.lng}
        </span>
        <span>|</span>
        <span>{info.zoom}</span>
      </>
    );
  }
  if (info?.zoom) return <span>{info.zoom}</span>;
  return <span>Cargando información...</span>;
}
